import { Select } from "antd";
import { styled } from "styled-components";

export const InputSelectStyle = styled(Select)``;


